import api from './axiosConfig';

/**
 * 用戶認證服務
 */
const authService = {
  /**
   * 用戶登入
   * @param {Object} credentials - 登入憑證
   * @param {string} credentials.username - 用戶名
   * @param {string} credentials.password - 密碼
   * @param {string} credentials.userType - 用戶類型
   * @returns {Promise} - 包含用戶信息和令牌的響應
   */
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
    }
    return response.data;
  },

  /**
   * 訪客OTP登入
   * @param {Object} credentials - OTP憑證
   * @param {string} credentials.otp - 一次性密碼
   * @returns {Promise} - 包含訪客信息和令牌的響應
   */
  loginWithOtp: async (credentials) => {
    const response = await api.post('/auth/login/otp', credentials);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
    }
    return response.data;
  },

  /**
   * 登出
   */
  logout: () => {
    localStorage.removeItem('token');
  },

  /**
   * 獲取當前用戶信息
   * @returns {Promise} - 包含用戶信息的響應
   */
  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  /**
   * 重置密碼請求
   * @param {Object} data - 包含用戶電子郵件的對象
   * @returns {Promise} - API響應
   */
  requestPasswordReset: async (data) => {
    const response = await api.post('/auth/password-reset-request', data);
    return response.data;
  },

  /**
   * 確認密碼重置
   * @param {Object} data - 包含新密碼和令牌的對象
   * @returns {Promise} - API響應
   */
  confirmPasswordReset: async (data) => {
    const response = await api.post('/auth/password-reset-confirm', data);
    return response.data;
  },

  /**
   * 檢查用戶是否已認證
   * @returns {boolean} - 是否已認證
   */
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  }
};

export default authService; 